import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IndicatorIcon } from '../enums/indicator-icon.enum';
import { IndicatorStyle } from '../enums/indicator-style.enum';
import { VerificationHistory } from '../../model/cpl-verification-history.model';
import { CycleVerificationActions } from '../../supervision-management/compliance-items/compliance-item/enums/cycle-verification-actions.enum';
import { StateService } from '@uirouter/core';
import { CplItemType } from 'src/app/model/enum/cpl-item-type.enum';

export const DEFAULT_VERIFICATION_NAME = 'Comply'
@Component({
    selector:    'user-cycle-history-item',
    templateUrl: './user-cycle-history-item.component.html'
})
export class UserCycleHistoryItemComponent {
    @Input() historyItem: VerificationHistory;

    @Output() onMessagesClicked = new EventEmitter<string>();

    constructor(private stateService: StateService) 
    {}

    getActionText(historyItem:VerificationHistory) {
        const verificationByName = historyItem?.VerificationByName ?? DEFAULT_VERIFICATION_NAME
        switch (historyItem.VerificationStatus) {
            case CycleVerificationActions.SUBMITTED :
                return `Submitted by ${verificationByName}`;
            case CycleVerificationActions.APPROVED:
                return `Approved by ${verificationByName}`;
            case CycleVerificationActions.COMPLETED:
            case CycleVerificationActions.FINALIZED:
                return "Completed";
            case  CycleVerificationActions.DECLINED:
                return `Disapproved by ${verificationByName}`;
            case CycleVerificationActions.REOPENED:
                return  `Reopened by ${verificationByName}`;
            case CycleVerificationActions.FORGIVEN:
                return  `Forgiven by ${verificationByName}`;
            case CycleVerificationActions.NUDGED:
                return `Nudged by ${verificationByName}`;
            case CycleVerificationActions.MESSAGE:
                return `Messaged by ${verificationByName}`;
            case CycleVerificationActions.CREATED:
                return `Item Assigned by ${verificationByName}`;
            case CycleVerificationActions.DUE_DATE_CHANGED:
                return `Due Date Changed by ${verificationByName}`;
            default :
                return "";
        }
           
    }

    getStatusStyle(statusId: number) {
        switch(statusId) {
            case CycleVerificationActions.REOPENED:
                return IndicatorStyle.STEP_REOPENED;
            case CycleVerificationActions.APPROVED:
                return IndicatorStyle.STEP_APPROVED;
            case CycleVerificationActions.COMPLETED:
            case CycleVerificationActions.FINALIZED:
                return IndicatorStyle.STEP_COMPLETED;
            case CycleVerificationActions.SUBMITTED:
                return IndicatorStyle.STEP_SUBMITTED;
            case CycleVerificationActions.DECLINED:
                return IndicatorStyle.DECLINED;
            case CycleVerificationActions.FORGIVEN:
                return IndicatorStyle.FORGIVEN;  
            case CycleVerificationActions.NUDGED:
                return IndicatorStyle.NUDGED;
            case CycleVerificationActions.MESSAGE:
                return IndicatorStyle.MESSAGE;
            case CycleVerificationActions.CREATED:
                return IndicatorStyle.CREATED;
            case CycleVerificationActions.DUE_DATE_CHANGED:
                return IndicatorStyle.DUE_DATE_CHANGED;
            default:
                return IndicatorStyle.NONE;
        }
    }

    getStatusIcon(statusId: number) {
        switch(statusId) {
            case CycleVerificationActions.SUBMITTED:
            case CycleVerificationActions.REOPENED:
                return IndicatorIcon.INBOX;
            case CycleVerificationActions.APPROVED:
            case CycleVerificationActions.COMPLETED:
            case CycleVerificationActions.FINALIZED:
                return IndicatorIcon.CHECK;
            case CycleVerificationActions.DECLINED:
                return IndicatorIcon.TIMES;
            case CycleVerificationActions.FORGIVEN:
                return IndicatorIcon.ASTERISK;
            case CycleVerificationActions.NUDGED:
                return IndicatorIcon.POINT;
            case CycleVerificationActions.MESSAGE:
                return IndicatorIcon.MESSAGE;
            case CycleVerificationActions.CREATED:
                return IndicatorIcon.CREATED;
            case CycleVerificationActions.DUE_DATE_CHANGED:
                return IndicatorIcon.CALENDAR;
            default:
                return IndicatorIcon.NONE;
        }
    }

    messageClicked(cplHistoryId: string) {
        this.onMessagesClicked.emit(cplHistoryId);
        this.stateService.go('authenticated.messages.history', {
            historyId: cplHistoryId,
            typeId: CplItemType.COMPLIANCE,
            page: 1
        });
    }
}